<template>
    <header class="header">
        <nav class="navbar navbar-expand-sm">
            <router-link class="navbar-brand" to="/">
                <img id="logo" alt="Regents logo" src="@/assets/Regents_R_white.png">
                Regents School of Austin
            </router-link>
            <button class="navbar-toggler ml-auto mr-auto bg-white mb-1" type="button" data-toggle="collapse" data-target="#navbarLinks" aria-controls="#navbarLinks" aria-expanded="false" aria-label="Toggle navigation">
                <span class="small d-flex">menu</span>
            </button>
            <div class="collapse navbar-collapse" id="navbarLinks">
                
                <ul v-if="isLoggedIn && hasAccess" class="navbar-nav mr-auto">
                    <li class="nav-item">
                        <router-link class="nav-link" :to="{name: 'announcements'}">
                            Announcements
                        </router-link>
                    </li> 
                    <li class="nav-item">
                        <router-link class="nav-link" :to="{name: 'detentions'}">
                            Detentions
                        </router-link>
                    </li>
                    <li class="nav-item">
                        <router-link class="nav-link" :to="{name: 'allStudents'}">
                            Students
                        </router-link>
                    </li>
                </ul>
                <a v-if="isLoggedIn" @click='signOut' role="button" class="btn ml-auto my-2 my-sm-0">Sign out</a>
                <button v-else @click="signIn" class="btn btn-sm btn-light ml-auto"> Sign in with Google
                </button>
            </div>
        </nav>
    </header>
</template>


<script>
import Firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
import Router from '@/router.js'

export default {
    name: "Navbar",
    data () {
        return {
            isLoggedIn: !!Firebase.auth().currentUser,
        }
    },
    computed: {
        hasAccess: function () {
            return this.$root.sharedState.accessLevel >= 2
        }
    },
    methods: {
        signIn: function () {
            Firebase.auth().setPersistence(Firebase.auth.Auth.Persistence.SESSION).then(() => {
                var provider = new Firebase.auth.GoogleAuthProvider();
                provider.setCustomParameters({prompt: 'select_account'});
                Firebase.auth().signInWithRedirect(provider);
            })
        },
        signOut: function () {
            Firebase.auth().signOut().then(() => {
                this.isLoggedIn = false
                Router.push('/')
            })
            .catch((error) => {console.log("Error logging out user", error)})
        }
    },
}
</script>
